/** Sidebar width — CSS variable consumed by calendar layout (nav-agnostic). */
export const CALENDAR_SIDEBAR_WIDTH = '14rem'
